import * as React from 'react';
import Big from 'big.js';

import { IOrder } from '@market/interfaces/IOrder';
import noPhotoMale from '@images/no_photo_male.png';
import noPhotoCompany from '@images/no_photo_company.png';

export const displayWarnings = (messages: string[]) => {
  return messages.map((el, i) => (
    <p key={i} dangerouslySetInnerHTML={{ __html: el }} />
  ));
};

export const noLeadingZeros = (value: string | number) => {
  return Number(value).toString();
};

export const noExponential = (value: string | number) => {
  let tmp = '';
  if (value.toString().includes('e-')) {
    tmp = Number(value).toFixed(8);
  }
  return tmp || value;
};

export const sortOrdersByPriceAsc = (a: IOrder, b: IOrder) => {
  if (new Big(a.price).lt(Number(b.price))) {
    return -1;
  }
  if (new Big(a.price).gt(Number(b.price))) {
    return 1;
  }
  return 0;
};

export const sortOrdersByPriceDesc = (a: IOrder, b: IOrder) => {
  return Number(new Big(b.price).minus(a.price));
};

export const sortOrdersByDateAsc = (a: IOrder, b: IOrder) => {
  return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
};

export const investorCanSellShares = (hasAnyShares: boolean, hasNoActiveSells: boolean) => {
  return hasAnyShares && hasNoActiveSells;
};

export const investorHasAnyShares = (numberOfShares: number, shareSymbol?: string) => {
  const status = numberOfShares > 0 ? true : false;
  return {
    status,
    message: status ? null : `You don’t have any [${shareSymbol}] Shares yet to sell`,
  };
};

//TODO: Remove when PaymentDetails will be refactored and rename newCompanyPhoto
export const companyPhoto = (companyData: any) => {
  const { company_avatar } = companyData;
  let url = noPhotoCompany;
  if (company_avatar && company_avatar.id !== null) {
    url = companyData.company_avatar.url || url;
  }
  return { backgroundImage: `url(${url})` };
};

export const newCompanyPhoto = (companyAvatar: any) => {
  let url = noPhotoCompany;
  if (companyAvatar && companyAvatar.id !== null) {
    url = companyAvatar.url || url;
  }
  return { backgroundImage: `url(${url})` };
};

export const investorPhoto = (avatar: string) => {
  return { backgroundImage: `url(${avatar || noPhotoMale})` };
};

export const investorHasActiveSellShares = (hasActiveOrders: boolean) => {
  return {
    status: hasActiveOrders,
    message: hasActiveOrders ? 'Currently you can have only one open order per asset. ' : null,
  };
};

export const isCertifiedAndVerified = (isCertified: boolean, isVerified: boolean) => {
  const status = isCertified && isVerified;

  return {
    status,
    message: status ? null : 'Complete your investor profile information',
  };
};
